export default {
  ROOT: '/',
  HOME: '/home',
  DOMAIN: '/domain-for-sale',
  PROJECTS: '/projects',
  PROJECT: '/project/:id',
  CONTACT: '/contact',
  SERVICES: '/service-detail',
  TEAMMEMBER: '/team-member/:id',
  SEARCH: '/search',
};
